const helpModal = document.getElementById("help-modal");
const helpOpenButton = document.getElementById("help-open");
const helpCloseButton = document.getElementById("help-close");

// The element that had focus before the modal opened, so focus can be restored on close
let previouslyFocused = null;

export function initHelp() {
  helpOpenButton.addEventListener("click", openHelp);
  helpCloseButton.addEventListener("click", closeHelp);

  // Close when clicking the backdrop, but not when clicking inside the dialog
  helpModal.addEventListener("click", (event) => {
    if (event.target === helpModal) {
      closeHelp();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !helpModal.hidden) {
      closeHelp();
    }
  });
}

function openHelp() {
  previouslyFocused = document.activeElement;
  helpModal.hidden = false;
  helpCloseButton.focus();
}

function closeHelp() {
  helpModal.hidden = true;
  if (previouslyFocused) {
    previouslyFocused.focus();
    previouslyFocused = null;
  }
}
